module.exports = __webpack_public_path__ + "img/tally-3.cd7fa5cb.svg";